import React, {useEffect, useState} from 'react';
import {Flex, message} from "antd";
import { ShareAltOutlined } from '@ant-design/icons';
import style from "./ProductHeader.module.scss";
import {MdOutlineBookmark, MdOutlineBookmarkBorder, MdOutlineReport} from "react-icons/md";
import {BackButton, deleteBookmark} from "../../../../shared";
import {connect} from "react-redux";
import {getProductDetail, registerBookMark} from "../../actions/Product.action";
import {withRouter} from "../../../../utils/services/with-router";
import {ProductDetailHeaderProps} from "../../models";
import {useParams} from "react-router-dom";
import ReportPopup from "./ReportPopup";
import {StyledCard} from "./ProductDetailHeader.styled";

const ProductDetailHeader = ({registerBookMark ,bookmarked,deleteBookmark}:ProductDetailHeaderProps ) => {
    const [isBookmarked, setIsBookmarked] = useState<boolean>(false)
    const [openReportModal, setOpenReportModal] = useState<boolean>(false)
    const { id } = useParams();
    const _registerBookMark = () => {
        let model = {
            productId : id
        }
        registerBookMark(model)
            .then((data: any) => {
                if (data.payload?.data) {

                    setIsBookmarked(true);
                    message.success('محصول با موفقیت به علاقه مندی ها اضافه شد')

                }
            })
            .catch((e: any) => {
            });
    };
    const _deleteBookMark = () => {
        deleteBookmark(id)
            .then((data: any) => {
                if (data.payload?.data) {

                    setIsBookmarked(false);
                    message.info('محصول با موفقیت از علاقه مندی ها حذف شد')


                }
            })
            .catch((e: any) => {
            });
    };
    useEffect(() => {
        setIsBookmarked(bookmarked)
    }, [bookmarked]);
    const onCansel = () => {
      setOpenReportModal(false)
    }
    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: document.title,
                    text: "Check out this page!",
                    url: window.location.href,
                });
                console.log("Shared successfully");
            } catch (error) {
                console.error("Error sharing:", error);
            }
        } else {
            alert("Web Share API is not supported in your browser.");
        }
    };
    return (
        <StyledCard>
            <Flex className={style.productDetailHeader} justify={"space-between"}>
                <BackButton/>
                <Flex gap={"middle"}>
                    { isBookmarked ?<MdOutlineBookmark onClick={_deleteBookMark}    className={style.customIcon}/> :
                        <MdOutlineBookmarkBorder onClick={_registerBookMark}  className={style.customIcon}/>}
                    <MdOutlineReport onClick={() => setOpenReportModal(true)} className={style.customIcon}/>
                    <ShareAltOutlined onClick={() => handleShare()} className={style.customIcon}/>
                </Flex>

                <ReportPopup open={openReportModal} onCansel={onCansel}/>
            </Flex>
        </StyledCard>

    );
};

export default connect(null, {registerBookMark,deleteBookmark})(withRouter(ProductDetailHeader));

